export const COMMON = {
  PAGE_SIZE: 20,
  PAGE_NUM: 1,
  TASK_STATUS: [
    { id: 0, name: "未开始", color: "rgba(0, 0, 0, 0.65)" },
    { id: 1, name: "已完成", color: "#1890ff" },
    { id: 2, name: "进行中", color: "#52c41a" },
    { id: 3, name: "挂起", color: "#f5222d" },
    { id: 4, name: "测试中", color: "#faad14" }
  ],
  CONTRACT_TYPE: [
    { key: "1", name: "材料采购合同" },
    { key: "2", name: "劳务分包合同" },
    { key: "3", name: "专业分包合同" },
    { key: "4", name: "租赁合同" },
    { key: "-1", name: "设计合同" },
    { key: "-2", name: "设计外协合同" },
    { key: "-3", name: "施工合同" }
  ],
  PROJECT_STATUS: [
    { key: -99, value: "待定" },
    { key: -1, value: "营销放弃" },
    { key: 1, value: "营销跟踪" },
    { key: 2, value: "投标阶段" },
    { key: 3, value: "已中标" },
    { key: 4, value: "未中标" },
    { key: 5, value: "在建中" },
    { key: 6, value: "设计营销阶段" },
    { key: 7, value: "设计投标阶段" },
    { key: 8, value: "已中标" },
    { key: 9, value: "未中标" },
    { key: 10, value: "设计放弃" },
    { key: 11, value: "设计中" },
    { key: 12, value: "设计已完工" },
    { key: 13, value: "设计已关闭" },
    { key: 14, value: "停工项目" },
    { key: 15, value: "完工未送审" },
    { key: 16, value: "送审未审定" },
    { key: 17, value: "审定项目" },
    { key: 18, value: "关闭项目" }
  ],
  INVOICE_STATUS: [
    { key: "1", name: "待开票" },
    { key: "2", name: "已开票" },
    { key: "3", name: "已关闭" }
  ],
  MENU_MAP: {
    "/oa/FixedAssetsDetail": "/oa/FixedAssetsBookkeeping",
    "/oa/NewsDetail": "/oa/AnnouncementManagement"
  },
  ERROR_MESSAGE: [
    { code: 10000, msg: "接口验证异常" },
    { code: 10001, msg: "请求客户端错误" },
    { code: 10002, msg: "请求资源获取不到" },
    { code: 10003, msg: "请求客户端与服务端冲突" },
    { code: 10004, msg: "无权限" },
    { code: 10005, msg: "服务不可用" },
    { code: 10006, msg: "未授权" },
    { code: 10009, msg: "无效的网关" },
    { code: 10010, msg: "服务端内部错误" },
    { code: 10013, msg: "一定的时间内用户发送了太多的请求" },
    { code: 20000, msg: "json映射错误" },
    { code: 20001, msg: "json解析错误" },
    { code: 20002, msg: "请求不被接受" },
    { code: 20003, msg: "请求method不允许" },
    { code: 20004, msg: "请求类型不支持" },
    { code: 20100, msg: "认证异常" },
    { code: 20101, msg: "禁止访问" },
    { code: 20102, msg: "客户端认证失败" },
    { code: 20103, msg: "重定向uri找不到" },
    { code: 20104, msg: "不支持的 RespoecoType" },
    { code: 20105, msg: "Grant认证失败" },
    { code: 20106, msg: "授权服务器不支持的授权模式" },
    { code: 20107, msg: "授权服务器认证客户端，但没有授权" },
    { code: 20108, msg: "请求参数中缺少参数" },
    { code: 20109, msg: "指定的token是无效的" },
    { code: 20110, msg: "指定的scope是无效的" },
    { code: 20126, msg: 'Ticket过期' },
    { code: 20127, msg: '系统基础模块未开通或已过期，请联系管理员'},
    { code: 20128, msg: '用户在线人数已经达到上限，如需登入系统，请联系管理员'},
    { code: 30000, msg: "原格式异常" },
    { code: 30101, msg: "往来单位不存在" },
    { code: 30152, msg: "一个事项不能重复配置模版！" },
    { code: 30102, msg: "备用金借款付款单已经关闭或者付清" },
    { code: 30103, msg: "该组织编码已存在" },
    { code: 30201, msg: "员工入职生成工号异常" },
    { code: 30301, msg: "营销投标保证金状态异常非投标阶段" },
    { code: 30302, msg: "每个项目只能选择一次" },
    {
      code: 30303,
      msg: "同一年度相同预算类型、经营指标、预算主体的营销项目预算只能添加一次"
    },
    { code: 30401, msg: "客户名称、营销项目名称已存在" },
    { code: 30404, msg: "每个项目只能选择一次" },
    { code: 30501, msg: "每个项目只能选择一次" },
    { code: 30502, msg: "项目章、技术专用章只能申请一次" },
    { code: 30503, msg: "不能选择过早的所属月份" },
    { code: 30504, msg: "当前上级分类下分类编码已存在" },
    { code: 30505, msg: "当前上级分类下分类名称已存在" },
    { code: 30506, msg: "当前分类下此材料已经存在" },
    { code: 30507, msg: "当前合同下此材料已经存在" },
    { code: 30601, msg: "此预缴税金财务已经支付，无法修改" },
    { code: 30602, msg: "此垫资金额财务已经确认，无法修改" },
    { code: 30603, msg: "此报销单财务已经支付，无法修改" },
    { code: 30604, msg: "此单据已经支付或者关闭，无法再次支付" },
    { code: 30605, msg: "此发票已存在,无法添加" },
    { code: 30606, msg: "已开票或已关闭" },
    { code: 30701, msg: "印章已领用，无法再领用" },
    { code: 30702, msg: "印章已归还，无法再归还" },
    { code: 30703, msg: "合同已用印" },
    { code: 30704, msg: "印章已领用，无法编辑" },
    { code: 31019, msg: "成本科目模板名称不能重复!" },
    { code: 31020, msg: "成本科目编号/名称不能重复!" },
    { code: 40101, msg: "此接口方法已被菜单使用,不能删除" },
    { code: 40102, msg: "此接口方法已被角色使用,不能删除" },
    { code: 40103, msg: "此接口方法别名已存在" },
    { code: 40104, msg: "此接口方法类型以及地址已存在" },
    { code: 40128, msg: "该水印已经存在" },
    { code: 60104, msg: "所选套餐无效！" },
    { code: 60105, msg: "当前状态订单不可删除！" },
    { code: 60106, msg: "该订单状态异常,不可支付!" },
    { code: 60107, msg: "请先删除套餐产品关联关系!" },
    { code: 60108, msg: "当前订单状态不可以确认!" },
    { code: 60109, msg: "当前发票类型存在重复!" },
    { code: 60110, msg: "当前发票明细存在重复!" },
    { code: 40105, msg: "该账号已有业务数据，不能删除！请先删除业务数据。" },
    { code: 30804, msg: "该需求已回复，不能删除！" },
    { code: 30805, msg: "该需求已回复，不能编辑！" },
    { code: 70103, msg: "附件库文件名已存在" }
  ]
};
